import { createReducer } from "@reduxjs/toolkit";
import {
    InitialState,
} from "./types";
import { reducerHelper } from '../reducerHelper'
import { shiftCurrent, shiftOpen, shiftClose, shiftCreate, shiftDetail, shiftAutoFill } from "./actions";

const initialState: InitialState = {
    shiftCurrent: {
        data: null,
        loading: false,
        error: null,
    },
    shiftOpen: {
        loading: false,
        error: null,
        data: false
    },
    shiftClose: {
        loading: false,
        error: null,
        data: false
    },
    shiftCreate: {
        loading: false,
        error: null,
    },
    shiftDetail: {
        data: null,
        loading: false,
        error: null,
    },
    shiftAutoFill: {
        loading: false,
        error: null,
    },
}

export const shiftReducer = createReducer(initialState, (builder) => {
    reducerHelper<InitialState>(builder, shiftCurrent, 'shiftCurrent', null);
    reducerHelper<InitialState>(builder, shiftOpen, 'shiftOpen', false);
    reducerHelper<InitialState>(builder, shiftClose, 'shiftClose', false);
    reducerHelper<InitialState>(builder, shiftCreate, 'shiftCreate', null);
    reducerHelper<InitialState>(builder, shiftDetail, 'shiftDetail', null);
    reducerHelper<InitialState>(builder, shiftAutoFill, 'shiftAutoFill', null);
})
